import { TYPE_MAPPING } from "@/stores/types/api.types";

type TypeDetails = {
  type?: string;
  anyOf?: any[];
  items?: any;
  enum?: any[];
};

type TypeResult = {
  type: string;
  schemaType?: string;
  nestLevel: number;
};

export function getType(details: TypeDetails, nestLevel: number = 0): TypeResult {
  let type: string | null = null;

  if ("anyOf" in details) {
    // AnyOf is to support Unions or Any types
    type = "string";
  } else if (!details?.type && details?.enum) {
    // Handle enum types without explicit type - treat as string
    type = "string";
  } else if (!details?.type) {
    throw new Error("Complex types are not supported, only primitive types are supported");
  } else {
    type = TYPE_MAPPING[details.type as keyof typeof TYPE_MAPPING]
      ? TYPE_MAPPING[details.type as keyof typeof TYPE_MAPPING]
      : details.type;
  }

  if (type === "array") {
    nestLevel++;
    if (!details.items) {
      // Sometimes there are no items but e.g. prefixItems, these should be put in the right type by the api
      // Later it can be investigated how this can be done correctly in excel, however it seems like a matrix of values needs to have the same type
      type = "string";
    } else {
      return getType(details.items, nestLevel);
    }
  }

  if (nestLevel > 2) {
    throw Error("Required nested level of list is not support by Excel Custom Functions");
  }

  return { type, schemaType: details.type, nestLevel };
}
